import React from 'react';
import PropTypes from 'prop-types';
import { VideoButton as PlayButton, Icon } from '@honda-canada/design-system-react';
import themeStyles from './styles/NoticeSection.styles';
import { videoTypes } from '../../utils/constants';

const VideoButtonAsLink = themeStyles.apply('a', 'VideoButtonAsLink');

const VideoButton = ({ videoType, onClick, videoLink }) => {
  if (videoType === videoTypes.unsupported) {
    return (
      <VideoButtonAsLink href={videoLink} target="_blank">
        <Icon name="play" iconSize={['medium', 'large']} background="white" />
      </VideoButtonAsLink>
    );
  }
  return (
    <PlayButton onClick={onClick} className="videoButton" aria-label="play button">
      <Icon name="play" iconSize={['medium', 'large']} background="white" />
    </PlayButton>
  );
};

VideoButton.propTypes = {
  videoType: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  videoLink: PropTypes.string,
};

export default VideoButton;
